export default function SlideInBody({
  children,
}: {
  children: React.ReactNode
}) {
  return <div className="slidein__body">{children}</div>
}
